export default __webpack_public_path__ + "static/media/3023.3ad70768.jpg";